import React from 'react';
import {get} from 'lodash';
import className from 'classnames';
import {TransitionGroup, CSSTransition} from 'react-transition-group';
import * as Cookies from 'js-cookie';

import {
  COOKIES_KEY_NOTIFICATION,
} from '../lib/helpers'

class Notification extends React.Component {
  static propTypes = {
  };

  static defaultProps = {
  };

  static NOTIFICATION_TYPES = {
    error: '__error__',
    success: '__success__',
    warning: '__warning__',
  }

  state = {
    notifications: [],
  };

  componentDidMount = () => {
    const cookie = Cookies.get(COOKIES_KEY_NOTIFICATION)

    if (cookie) {
      this.setState({
        notifications: [
          JSON.parse(cookie),
        ],
      }, () => {
        Cookies.remove(COOKIES_KEY_NOTIFICATION)
      })
    }
  }

  componentDidUpdate = () => {
    window.setTimeout(() => {
      this.setState({
        notifications: [],
      })
    }, 5000)
  }

  render = () => {
    return (
      <div className='Notification'>
        <TransitionGroup
          component='ul'
          className='Notification__ul'
        >
          {get(this.state, 'notifications', []).map((x, i) => (
            <CSSTransition
              key={i}
              classNames='Notification__ul__li'
              timeout={{ enter: 500, exit: 300 }}
            >
              <li
                className={className('Notification__ul__li', {
                  'Notification__ul__li--error': x.type == Notification.NOTIFICATION_TYPES.error,
                  'Notification__ul__li--success': x.type == Notification.NOTIFICATION_TYPES.success,
                  'Notification__ul__li--warning': x.type == Notification.NOTIFICATION_TYPES.warning,
                })}
              >
                {(() => {
                  const message = (_.isObject(x.message) || !x.message ) ? x.key : x.message.replace(/\+/g, ' ')

                  return (
                    <p className='Notification__ul__li__p' title={x.key}>
                      {x.type == Notification.NOTIFICATION_TYPES.error ?
                        <React.Fragment>
                          <strong>Error:</strong> {message}
                        </React.Fragment>
                      :
                        message
                      }
                    </p>
                  )
                })()}
              </li>
            </CSSTransition>
          ))}
        </TransitionGroup>
      </div>
    );
  }
}

export default Notification;
